import React from 'react';

import './styles.css';

export const Shimmer = ({style}) => {
  return <div className={'box animate'}  style={style}/>;
};


